import { render, staticRenderFns } from "./list-telegram-rec.vue?vue&type=template&id=924804f0&scoped=true"
import script from "./list-telegram-rec.vue?vue&type=script&lang=js"
export * from "./list-telegram-rec.vue?vue&type=script&lang=js"
import style0 from "./list-telegram-rec.vue?vue&type=style&index=0&id=924804f0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "924804f0",
  null
  
)

export default component.exports